import { replaceCommaByPipe } from 'src/helpers';
import { PropertyStatus } from 'src/ts/enums';

export const DEFAULT_PROPERTY_STATUSES = [PropertyStatus.ACTIVE, PropertyStatus.DISABLED];

export type PropertyFilterInput = {
  /** Comma-joined ids. */
  companyIds?: string;
  statuses: PropertyStatus[];
};

/**
 * Builds the `filter` param for the properties list. The status clause replaces
 * the slice's `status!=ARCHIVED` default; sending both matches nothing.
 */
export const buildPropertyFilter = ({ companyIds, statuses }: PropertyFilterInput): string => {
  // A bare `status@>` reaches the API as one empty value and returns zero rows.
  const picked = statuses.length > 0 ? statuses : DEFAULT_PROPERTY_STATUSES;
  const clauses = [`status@>${picked.join('|')}`];

  // The API splits the filter string on commas first, so ids have to be piped.
  const companies = replaceCommaByPipe(companyIds);

  if (companies) {
    clauses.push(`company_id@>${companies}`);
  }

  return clauses.join(',');
};

/** The slice default and the dropdowns' default both narrow nothing. */
const UNNARROWED_FILTERS = [
  'status!=ARCHIVED',
  buildPropertyFilter({ statuses: DEFAULT_PROPERTY_STATUSES })
];

export const isPropertyFilterNarrowed = (filter?: string): boolean =>
  Boolean(filter) && !UNNARROWED_FILTERS.includes(filter as string);
